
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M11.05 21C11.55 21 11.99 20.63 12.04 20.13C12.45 15.86 15.85 12.46 20.12 12.05C20.62 12 21 11.57 21 11.06C21 10.47 20.49 10 19.9 10.06C14.71 10.58 10.58 14.71 10.06 19.89C10 20.48 10.46 21 11.05 21ZM18 21H21V18C19.34 18 18 19.34 18 21ZM15.09 21C15.58 21 15.99 20.64 16.07 20.15C16.43 18.07 18.07 16.43 20.15 16.07C20.64 15.99 21 15.58 21 15.09C21 14.48 20.46 14 19.86 14.09C16.9 14.57 14.57 16.9 14.09 19.86C13.99 20.46 14.48 21 15.09 21ZM12.97 3.02002C12.47 3.02002 12.03 3.39002 11.98 3.89002C11.57 8.16002 8.17002 11.56 3.90002 11.97C3.40002 12.02 3.02002 12.45 3.02002 12.96C3.02002 13.55 3.53002 14.02 4.12002 13.96C9.31002 13.44 13.44 9.31002 13.96 4.13002C14.03 3.55002 13.57 3.02002 12.97 3.02002ZM6.03002 3.02002H3.03002V6.02002C4.69002 6.02002 6.03002 4.68002 6.03002 3.02002ZM8.94002 3.02002C8.45002 3.02002 8.04002 3.38002 7.96002 3.87002C7.60002 5.95002 5.96002 7.59002 3.88002 7.95002C3.39002 8.04002 3.03002 8.44002 3.03002 8.94002C3.03002 9.55002 3.57002 10.03 4.17002 9.94002C7.13002 9.46002 9.46002 7.13002 9.94002 4.17002C10.03 3.56002 9.54002 3.02002 8.94002 3.02002Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-leak-add`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconLeakAdd

    ```js
    <b-new-b-icon-leak-add />
    ```
</docs>


